import React from 'react';

function ItemsPerPage({ numberOfElements, size }) {
  return (
    <div className="itemsPerPage">
      Exibindo resultados {numberOfElements || 0} de {size || 0}
    </div>
  );
}

export default ItemsPerPage;
